var React = require('react');

function SolarGenerating (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.83333 3.33317V0.666504H5.83333V3.33317H1.83333ZM0.5 27.3332H12.5V21.9998H1.56667L0.5 27.3332ZM6 10.4332L4.1 8.5665L6.93333 5.73317L8.83333 7.59984L6 10.4332ZM2.1 19.3332H12.5V13.9998H3.16667L2.1 19.3332ZM13.8333 7.33317C11.9889 7.33317 10.4167 6.68317 9.11667 5.38317C7.81667 4.08317 7.16667 2.51095 7.16667 0.666504H20.5C20.5 2.51095 19.85 4.08317 18.55 5.38317C17.25 6.68317 15.6778 7.33317 13.8333 7.33317ZM12.5 12.6665V8.6665H15.1667V12.6665H12.5ZM15.1667 27.3332H27.1667L26.1 21.9998H15.1667V27.3332ZM15.1667 19.3332H25.5667L24.5 13.9998H15.1667V19.3332ZM21.6667 10.4332L18.8667 7.59984L20.7333 5.73317L23.5667 8.53317L21.6667 10.4332ZM21.8333 3.33317V0.666504H25.8333V3.33317H21.8333Z","fill":"#FFB432"}));
}

SolarGenerating.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = SolarGenerating;

SolarGenerating.default = SolarGenerating;
